import { render } from "./Reminders.vue?vue&type=template&id=0d2ff3dd&scoped=true"
import script from "./Reminders.vue?vue&type=script&lang=js"
export * from "./Reminders.vue?vue&type=script&lang=js"

import "./Reminders.vue?vue&type=style&index=0&id=0d2ff3dd&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0d2ff3dd"]])

export default __exports__